import { Listbox } from "@headlessui/react";

import Dropdown from "components/atoms/Dropdown";
import Img from "components/atoms/Img";
import Banner from "components/organisms/Banner";

const RestrictedCountrieslist = ({ dataJson }) => {
  const dataCountries = [
    /* Africa */ [
      "Niger",
      "Burkina Faso",
      "Burundi",
      "Central African Republic",
      "Democratic Republic of the Congo",
      "Equatorial Guinea",
      "Guinea - Bissau",
      "Libya",
      "Mali",
      "Morocco",
      "Nigeria",
      "Senegal",
      "Somalia",
      "South Sudan",
      "Sudan",
      "Uganda",
      "Tanzania",
      "Mozambique",
      "Chad",
      "Comoros"
    ].sort((a, b) => a.localeCompare(b)),
    /* Asia */ [
      "Cambodia",
      "Jordan",
      "Myanmar",
      "Pakistan",
      "Philippines",
      "Syria",
      "Turkey",
      "Yemen",
      "Iran",
      "The Democratic People’s Republic of Korea",
      "Iraq",
      "Afghanistan",
      "Turkmenistan",
    ].sort((a, b) => a.localeCompare(b)),
    /* Australia/Oceania */ [
      "American Samoa",
      "Fiji",
      "Guam",
      "Palau",
      "Samoa",
      "Vanuatu",
    ].sort((a, b) => a.localeCompare(b)),
    /* Europe */ [
      "Albania",
      "Crimea Region",
      "Donetsk Region",
      "Luhansk Region",
      "Gibraltar",
    ].sort((a, b) => a.localeCompare(b)),
    /* North America */ [
      "Barbados",
      "Haiti",
      "Jamaica",
      "US Virgin Islands",
      "Nicaragua"
    ].sort((a, b) => a.localeCompare(b)),
    /* South America */ ["Trinidad and Tobago", "Venezuela", "Cuba"].sort(
      (a, b) => a.localeCompare(b)
    ),
  ];

  const place = [
    "Africa",
    "Asia",
    "Australia/Oceania",
    "Europe",
    "North America",
    "South America",
  ];

  function renderData(as2D) {
    let sOut = ` <table class="table-policy jurisdictions table">
            <thead>
              <tr class="border-b border-bbc-brand-800">
                <th class="text-left text-bbc-brand-800 text-sm font-medium pl-9 p-3 leading-6 whitespace-nowrap">Africa</th>
                <th class="text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap">Asia</th>
                <th class="text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap">Australia/Oceania</th>
                <th class="text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap">Europe</th>
                <th class="text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap">North America</th>
                <th class="text-left text-bbc-brand-800 text-sm font-medium pr-9 p-3 leading-6 whitespace-nowrap">South America</th>
              </tr>
            </thead>`;

    const childrenMaxLength = dataCountries.reduce((maxChildren, current) => {
      return current.length > maxChildren.length ? current : maxChildren;
    });

    for (let x = 0; x < childrenMaxLength.length; x++) {
      // For each col
      sOut += "<tr class=' border-t border-bbc-neutral-500'>";
      for (let y = 0; y < as2D.length; y++) {
        // For each row
        sOut += `<td class='first:pl-9 px-3 py-2 leading-6 text-[14px] text-bbc-gray'>${
          as2D[y][x] ? as2D[y][x] : " "
        }</td>`;
      }
      sOut += "</tr>";
    }
    sOut +=
      "<tr class='border-t border-bbc-brand-800'><td colspan='6' class='py-3 px-9 text-[14px] text-bbc-gray'>Note: Nationalities under consideration are applicable to all members of your company,including directors, shareholders and beneficial owners.</td></tr>";
    sOut += "</table>";

    return sOut;
  }

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-600"
        breadcrumbs={dataJson.breadcrumbs}
        title={dataJson.title}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10",
          textColor: "banner-title-gradient-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={`/assets/images/${dataJson.banner_image}`}
            wrapper={{
              className: "bbc-banner-image-country xl:top-28",
            }}
            className="w-full"
            width={557}
            height={459}
            priority={true}
            alt="banner-img"
          />
        }
        bgColor={"bg-bbc-terms-policy"}
      >
        <div className="lg:py-6"></div>
      </Banner>
      <div className="mt-10 mb-10 lg:mt-20 lg:mb-20">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <div className="content">
                  <p className="mb-3 text-center text-bbc-gray lg:text-left">
                    Before proceeding to the incorporation process, kindly note
                    that BBCIncorp DOES NOT provide services for nationalities
                    under the below list.
                  </p>

                  <p className="mb-6 text-center text-bbc-gray lg:text-left">
                    The list is made based on recommendations by credible
                    sources such as FATF as part of our effort to comply with
                    AML/CTF regulations and are reviewed and updated from time
                    to time.
                  </p>
                  <h5 className="font-weight-bold mb-10 text-center text-base font-medium text-bbc-brand-700">
                    High-risk and non-cooperative jurisdictions
                  </h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: renderData(dataCountries),
                    }}
                    className="shadow-bbc hidden rounded-3xl bg-white lg:block"
                  ></div>
                  <div className="block lg:hidden">
                    {dataCountries.map((item, index) => (
                      <Dropdown
                        key={index}
                        activeIndex={place[index]}
                        className="dropdown-default shadow-bbc relative mt-3 h-full w-full text-sm text-bbc-brand-800 first:mt-0"
                        optionsClass="absolute mt-6"
                        optionsStyle={{ zIndex: 21 }}
                      >
                        <div className="shadow-bbc shadow-bbc rounded-xl bg-white">
                          {item.map((item) => {
                            return (
                              <Listbox.Option
                                key={item}
                                value={item}
                                as="div"
                                className="block border-b border-bbc-neutral-500 last:border-b-0"
                              >
                                {() => (
                                  <div
                                    className={
                                      "block select-none px-4 py-3 !font-normal text-bbc-black"
                                    }
                                  >
                                    {item}
                                  </div>
                                )}
                              </Listbox.Option>
                            );
                          })}
                        </div>
                      </Dropdown>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RestrictedCountrieslist;
